export const SCHOOL_SERVICES_HEAD = "Jefe de Departamento de Servicios Escolares";
export const POSTGRADUATE_HEAD = "Jefe de la División de Estudios de Posgrado e Investigación";

export const DEPARTMENT_HEADS = [
    SCHOOL_SERVICES_HEAD,
    POSTGRADUATE_HEAD
];